export default __webpack_public_path__ + "static/media/empty_truck.38d54068.svg";